import { render, staticRenderFns } from "./MainReceipt.vue?vue&type=template&id=e123a2bc&scoped=true&"
import script from "./MainReceipt.vue?vue&type=script&lang=ts&"
export * from "./MainReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./MainReceipt.vue?vue&type=style&index=0&id=e123a2bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e123a2bc",
  null
  
)

export default component.exports